<template>
  <header class="app-header">
    <nav class="navBar" v-if="!['login'].includes($route.name)">
      <b-navbar toggleable="xl" variant="faded" type="light">
        <b-navbar-brand href="/" class="brand">
          <img class="nav-logo" src="../../../src/assets/images/logo.png" alt="منصة البارون" />
          <span class="brand-text">
            <span class="brand-name">منصة البارون</span>
            <span class="brand-version">{{ brandVersion }}</span>
          </span>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="nav-items">
            <b-nav-item @click="goToRoute('landingPage')">الرئيسية</b-nav-item>
            <b-nav-item @click="goToRoute('courses')">المواد</b-nav-item>
            <b-nav-item @click="goToRoute('aboutus')">من نحن</b-nav-item>
            <b-nav-item @click="goToRoute('contactus')">تواصل معنا</b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav class="nav-items-left mr-auto">
            <b-nav-item
              v-if="!isLoggedIn"
              class="login-link"
              @click="goToRoute('login')">
              تسجيل الدخول
            </b-nav-item>

            <b-dropdown
              v-else
              size="md"
              id="dropdown-1"
              :right="true"
              class="user-menu"
              variant="outline-brand">
              <template #button-content>
                <span class="user-avatar">{{ userInitial }}</span>
                <span class="user-name">{{ username }}</span>
              </template>
              <b-dropdown-item @click="goToRoute('myCourses')">
                المواد الخاصه بي
              </b-dropdown-item>
              <b-dropdown-item @click="goToRoute('account')">
                تعديل الحساب
              </b-dropdown-item>
              <b-dropdown-item v-b-modal.modal-logout>
                تسجيل الخروج
              </b-dropdown-item>
            </b-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-modal
        id="modal-logout"
        size="sm"
        centered
        hide-header
        hide-footer
        modal-class="logout-modal"
        content-class="logout-modal-content"
        body-class="logout-modal-body"
        aria-labelledby="logout-modal-title">
        <div class="logout-badge" aria-hidden="true">
          <i class="fa fa-sign-out"></i>
        </div>
        <h2 id="logout-modal-title" class="logout-title">تسجيل الخروج</h2>
        <p class="logout-text">هل تريد تسجيل الخروج من منصة البارون؟</p>
        <div class="logout-actions">
          <button type="button" aria-label="الخروج" class="logout-btn logout-btn-confirm" @click="logout()">
            الخروج
          </button>
          <button type="button" aria-label="الغاء" class="logout-btn logout-btn-cancel" @click="$bvModal.hide('modal-logout')">
            الغاء
          </button>
        </div>
      </b-modal>
    </nav>

    <!-- Navbar for login page -->
    <nav class="navBar" v-else>
      <b-navbar toggleable="xl" variant="faded" type="light">
        <b-navbar-brand href="/" class="brand">
          <img class="nav-logo" src="../../../src/assets/images/logo.png" alt="منصة البارون" />
          <span class="brand-text">
            <span class="brand-name">منصة البارون</span>
            <span class="brand-version">{{ brandVersion }}</span>
          </span>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="nav-items">
            <b-nav-item @click="goToRoute('landingPage')">الرئيسية</b-nav-item>
            <b-nav-item @click="goToRoute('courses')">المواد</b-nav-item>
            <b-nav-item @click="goToRoute('aboutus')">من نحن</b-nav-item>
            <b-nav-item @click="goToRoute('contactus')">تواصل معنا</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </nav>
  </header>
</template>


<script>
import store from "../../store/index.js";

export default {
  data() {
    return {
      currentLang: null,
      version: ''
    };
  },
  computed: {
    isLoggedIn() {
      return !!store.getters.authToken;
    },
    username() {
      return store.getters.username || '';
    },
    userInitial() {
      return this.username ? this.username.trim().charAt(0).toUpperCase() : '؟';
    },
    isStagingUrl() {
      if (typeof window === 'undefined') {
        return false;
      }
      return window.location.href.toLowerCase().includes('staging');
    },
    brandVersion() {
      const prefix = this.isStagingUrl ? 'test - ' : '';
      return prefix + 'V ' + this.version;
    }
  },
  watch: {
    $route(to, from) {
      // No need to manually set username now
    },
  },
  methods: {
    goToRoute(name) {
      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    },
    logout() {
      store.commit("LOGOUT");
      this.$router.push({ name: "login" });
    },
    changeLang() {
      if (this.currentLang === 'ar') {
        store.commit("SET_LANG", "ar");
      } else {
        store.commit("SET_LANG", "ar");
      }
      location.reload();
    },
  },
  created() {
    this.lang = store.getters.getlang;
    this.currentLang = this.lang;
    this.version = process.env.VUE_APP_VERSION;
  }
};
</script>
<style>
  .app-header {
    position: sticky;
    top: 0;
    z-index: 1030;
  }

  .navBar .navbar {
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: saturate(180%) blur(10px);
    -webkit-backdrop-filter: saturate(180%) blur(10px);
    border-bottom: 1px solid rgba(20, 99, 86, 0.1);
    box-shadow: 0 2px 16px rgba(11, 61, 56, 0.06);
    padding: .6rem 3rem !important;
  }

  .brand {
    display: flex !important;
    align-items: center;
    gap: 12px;
  }

  .nav-logo {
    width: 48px;
    height: 48px;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(11, 61, 56, 0.15));
    transition: transform .2s ease;
  }
  .brand:hover .nav-logo {
    transform: scale(1.05);
  }

  .brand-text {
    display: flex;
    flex-direction: column;
    line-height: 1.15;
  }
  .brand-name {
    font-size: 18px;
    font-weight: 700;
    color: var(--brand-teal-dark);
    letter-spacing: .2px;
  }
  .brand-version {
    font-size: 11px;
    color: #8a9a97;
  }

  .nav-items {
    margin-inline-start: 24px;
  }
  .nav-items .nav-link {
    position: relative;
    color: #33403e !important;
    font-size: 16px !important;
    font-weight: 600;
    margin: 0 12px;
    padding: 8px 2px !important;
    transition: color .2s ease;
  }
  .nav-items .nav-link::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 2px;
    width: 0;
    height: 2px;
    background: var(--brand-teal-light);
    border-radius: 2px;
    transition: width .25s ease;
  }
  .nav-items .nav-link:hover {
    color: var(--brand-teal-dark) !important;
  }
  .nav-items .nav-link:hover::after,
  .nav-items .router-link-active::after {
    width: 100%;
  }

  .login-link .nav-link {
    color: var(--brand-teal) !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    border: 1.5px solid var(--brand-teal);
    border-radius: 999px;
    padding: 6px 20px !important;
    margin: 0 !important;
    transition: background-color .2s ease, color .2s ease;
  }
  .login-link .nav-link::after {
    display: none;
  }
  .login-link .nav-link:hover {
    background-color: var(--brand-teal);
    color: #fff !important;
  }

  .user-menu .btn {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1.5px solid var(--brand-teal);
    border-radius: 999px;
    padding: 4px 14px 4px 6px;
    color: var(--brand-teal-dark);
    background: rgba(20, 99, 86, 0.05);
  }
  .user-menu .btn:hover,
  .user-menu .btn:focus {
    background: rgba(20, 99, 86, 0.12);
    color: var(--brand-teal-dark);
    box-shadow: none;
  }
  .user-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: var(--brand-teal);
    color: #fff;
    font-size: 13px;
    font-weight: 700;
  }
  .user-name {
    font-size: 14px;
    font-weight: 600;
  }

  /* logout modal — built around the squircle logo mark */
  .logout-modal .modal-dialog {
    max-width: 360px;
  }
  .logout-modal .logout-modal-content {
    border: none;
    border-radius: 22px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 18px 48px rgba(11, 61, 56, 0.28);
  }
  .logout-modal .logout-modal-content::before {
    content: '';
    display: block;
    height: 5px;
    flex-shrink: 0;
    background: linear-gradient(135deg, var(--brand-teal-dark), var(--brand-teal-light));
  }
  .logout-modal .logout-modal-body {
    padding: 26px 24px 24px;
    text-align: center;
  }

  .logout-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 72px;
    margin: 0 auto 16px;
    /* same rounded-square silhouette and silver frame as the logo */
    border-radius: 24px;
    border: 3px solid #fff;
    background: linear-gradient(145deg, var(--brand-teal-dark), var(--brand-teal-light));
    box-shadow: 0 0 0 1px rgba(20, 99, 86, 0.18),
                0 8px 18px rgba(11, 61, 56, 0.22);
  }
  .logout-badge .fa {
    font-size: 30px;
    color: #fff;
    /* the glyph arrow points left-to-right; flip it for the RTL layout */
    transform: scaleX(-1);
  }

  .logout-title {
    margin: 0 0 6px;
    font-size: 19px;
    font-weight: 700;
    color: var(--brand-teal-dark);
    letter-spacing: .2px;
  }
  .logout-text {
    margin: 0 0 22px;
    font-size: 14.5px;
    color: #5c6b68;
  }

  .logout-actions {
    display: flex;
    gap: 10px;
  }
  .logout-modal .logout-btn {
    flex: 1;
    border: 1.5px solid transparent;
    border-radius: 999px;
    padding: 9px 18px;
    font-family: inherit;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: background .2s ease, color .2s ease, border-color .2s ease,
                box-shadow .2s ease, transform .15s ease;
  }
  .logout-modal .logout-btn:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(47, 174, 155, 0.35);
  }
  .logout-modal .logout-btn:active {
    transform: translateY(1px);
  }

  .logout-modal .logout-btn-confirm {
    color: #fff;
    background: linear-gradient(135deg, var(--brand-teal-dark), var(--brand-teal));
    box-shadow: 0 6px 14px rgba(11, 61, 56, 0.25);
  }
  .logout-modal .logout-btn-confirm:hover {
    background: linear-gradient(135deg, var(--brand-teal-dark), var(--brand-teal-light));
  }

  .logout-modal .logout-btn-cancel {
    color: var(--brand-teal-dark);
    background: transparent;
    border-color: rgba(20, 99, 86, 0.35);
  }
  .logout-modal .logout-btn-cancel:hover {
    background: rgba(20, 99, 86, 0.08);
    border-color: var(--brand-teal);
  }

  /* footer */
  .footer-img {
    padding: 10px 20px 40px 20px;
  }
  .footer-img img {
    display: block;
    margin: auto;
    width: 120px;
  }
  .footer-nav {
    text-align: center;
    width: 50%;
    margin: auto;
  }
  .footer-info {
    background-color: var(--brand-teal-dark) !important;
    color: white;
    padding: 0px !important;
    font-size: 13px;
  }
  .footer-btn {
    padding: 0px !important;
    margin-left: 3px;
    margin-right: 3px;
  }
  .footer-btn-group {
    float: left;
  }
  .footer-col-copy-right {
    padding-top: 13px;
  }

  @media (max-width: 991px) {

    .nav-logo {
      width: 40px;
      height: 40px;
    }
    .brand-name {
      font-size: 15px;
    }
    .navBar .navbar {
      padding: .5rem 1rem !important;
    }
    .nav-items {
      margin-inline-start: 0;
    }
    .nav-items .nav-link {
      margin: 4px 0;
    }
    .login-link {
      margin-top: 6px;
    }

    /* footer */
    .footer-col {
      text-align: center;
      float: center;
    }
    .footer-btn-group {
      margin: auto;
      float: unset;
    }
  }

  @media (max-width: 950px) {
    .footer-nav {
      text-align: center;
      width: 70%;
      margin: auto;
    }
  }
</style>
